import { useEffect } from "react";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

const TOUR_KEY = "ag_dashboard_tour_done_v1";

/**
 * Mega-Sprint B · Tour guiado para nuevos admins.
 * Se autodispara la primera vez. Skipable. Persistencia en localStorage.
 */
export function useDashboardTour({ enabled = true }) {
  useEffect(() => {
    if (!enabled) return;
    try {
      if (localStorage.getItem(TOUR_KEY) === "1") return;
    } catch { return; }

    // Esperar a que las secciones existan antes de arrancar
    const t = setTimeout(() => {
      const exists = (id) => !!document.querySelector(`[data-testid="${id}"]`);
      if (!exists("dashboard-stats")) return; // primera carga aún sin stats

      const d = driver({
        showProgress: true,
        animate: true,
        allowClose: true,
        nextBtnText: "Siguiente →",
        prevBtnText: "← Atrás",
        doneBtnText: "¡Listo!",
        steps: [
          {
            element: '[data-testid="dashboard-stats"]',
            popover: {
              title: "Tu panel de control",
              description: "Aquí ves de un vistazo ingresos, citas, beneficios y reservas previstas para hoy.",
            },
          },
          {
            element: '[data-testid="nav-calendar"], a[href="/calendar"]',
            popover: {
              title: "Calendario",
              description: "Gestiona reservas, bloquea horas y arrastra citas. Es el corazón del día a día.",
            },
          },
          {
            element: '[data-testid="nav-catalog"], a[href="/catalog"]',
            popover: {
              title: "Catálogo de servicios",
              description: "Crea tus servicios con precios, duración y deja que tus clientes los reserven online.",
            },
          },
          {
            element: '[data-testid="dashboard-affiliate"]',
            popover: {
              title: "Programa de afiliados",
              description: "Comparte tu enlace de referido y gana el 20 % MRR durante 12 meses por cada centro que registre y pague.",
            },
          },
          {
            element: '[data-testid="nav-marketplace"], a[href="/marketplace"]',
            popover: {
              title: "Marketplace público",
              description: "Tu centro aparece automáticamente con foto, valoración y reservas. Personalízalo en Ajustes.",
            },
          },
        ],
        onDestroyed: () => {
          try { localStorage.setItem(TOUR_KEY, "1"); } catch {}
        },
      });
      d.drive();
    }, 1500);

    return () => clearTimeout(t);
  }, [enabled]);
}

/** Permite relanzar el tour manualmente (útil para botón "Ver tutorial"). */
export function resetDashboardTour() {
  try { localStorage.removeItem(TOUR_KEY); } catch {}
}
